import { streamUserProfileImage } from '../services/userService';
import { streamStudentProfileImage } from '../services/studentService';

const cache = new Map();
const inflight = new Map();

function cacheKey(type, id) {
  return `${type}:${id}`;
}

const fetchers = {
  user: streamUserProfileImage,
  student: streamStudentProfileImage,
};

export function getCachedProfileImageUrl(type, id) {
  if (!type || !id) return null;
  return cache.get(cacheKey(type, id)) || null;
}

export function invalidateCachedProfileImage(type, id) {
  if (!type || !id) return;
  const key = cacheKey(type, id);
  const existing = cache.get(key);
  if (existing) {
    URL.revokeObjectURL(existing);
    cache.delete(key);
  }
}

export async function loadProfileImageUrl(type, id) {
  if (!type || !id) return null;

  const key = cacheKey(type, id);
  const hit = cache.get(key);
  if (hit) return hit;

  const pending = inflight.get(key);
  if (pending) return pending;

  const fetcher = fetchers[type];
  if (!fetcher) return null;

  const promise = fetcher(id)
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      cache.set(key, url);
      inflight.delete(key);
      return url;
    })
    .catch(() => {
      inflight.delete(key);
      return null;
    });

  inflight.set(key, promise);
  return promise;
}
